import { combineReducers } from 'redux';
import { BROKERBANS_REL, BROKERBANS_REL_MIX } from './types';
var brokerBansRel = function (state, action) {
    if (state === void 0) { state = { options: [], trans: {} }; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case BROKERBANS_REL:
            return payload;
        default:
            return state;
    }
};
var brokerBans = function (state, action) {
    if (state === void 0) { state = []; }
    var payload = action.payload, type = action.type;
    switch (type) {
        case BROKERBANS_REL_MIX:
            return payload;
        default:
            return state;
    }
};
export var SCOPE_NAME = 'REL';
var REL = combineReducers({
    brokerBansRel: brokerBansRel,
    brokerBans: brokerBans,
});
export default REL;
